import React, { useState, useEffect } from "react";
import { Box, CircularProgress, useTheme, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    backgroundColor: "#1976d2",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block",
  },
  loadingContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const IframeContent = ({ onLoad }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState("");

  // Detect device type based on breakpoints
  // xs: 0-599px (Mobile)
  // sm: 600-959px (Tablet)
  // md+: 960px+ (Desktop)
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'sm'));

  useEffect(() => {
    // Set image source based on device type
    const baseUrl = "https://skygeniwebapp.blob.core.windows.net/login-templates";

    if (isMobile) {
      setImageSrc(`${baseUrl}/Login_Mobile_RHS.webp`);
    } else if (isTablet) {
      setImageSrc(`${baseUrl}/Login_Tablet_RHS.webp`);
    } else {
      // md and above (Desktop, Large Desktop, XL)
      setImageSrc(`${baseUrl}/Login_Desktop_RHS.webp`);
    }
  }, [isMobile, isTablet]);

  const handleLoad = () => {
    setLoading(false);
    if (onLoad) {
      onLoad();
    }
  };

  const handleError = () => {
    setLoading(false);
    if (onLoad) {
      onLoad();
    }
  };

  return (
    <Box className={classes.imageContainer}>
      {loading && (
        <Box className={classes.loadingContainer}>
          <CircularProgress style={{ color: "#1976d2" }} />
        </Box>
      )}
      {imageSrc && (
        <img
          src={imageSrc}
          alt="SkyGeni Login"
          className={classes.image}
          onLoad={handleLoad}
          onError={handleError}
        />
      )}
    </Box>
  );
};

export default IframeContent;
